import React from 'react'

import { Box, Chip } from '@mui/material'

import { getStatusColor } from '../../../../shared/functions/Status/status.functions'
import { getOfferRequestStatusChips } from './OfferRequestStatus.functions'
import styles from './OfferRequestStatus.styles'
import { OfferRequestStatusProps } from './OfferRequestStatus.types'

/**
 * The Status cell of the admin order lists: where the order's items are, matching the order
 * details view, rather than the order's own status which stops at "Accepted by Traveler".
 */
const OfferRequestStatus: React.FC<OfferRequestStatusProps> = (props) => {
  const { offerRequest } = props

  const chips = getOfferRequestStatusChips(offerRequest)

  return (
    <Box sx={styles.container}>
      {chips.map((chip) => (
        <Chip key={chip.name} label={chip.label} color={getStatusColor(chip.name)} sx={styles.chip} />
      ))}
    </Box>
  )
}

export default OfferRequestStatus
